<template>
    <div class="floating-ball"
        :style="{ left: left + 'px', top: top + 'px', backgroundImage: `url(${headPortraitImage})` }"
        @mousedown.self="handleMouseDown" @touchstart.self="handleTouchStart" @mouseover.self="handleMouseOver"
        @mouseout.self="handleMouseOut">
        <div class="floating-ball-container">
            <div v-if="showGreetSb">
                <img v-if="roleType === 2" class="greet-sb-img"
                    :src="require('@/assets/images/theme1/common/assistant-text.png')">
                <img v-if="roleType === 1" class="greet-sb-img"
                    :src="require('@/assets/images/theme1/common/teaching-assistant-text.png')">
            </div>
        </div>
        <div style="position: relative;">
            <div v-if="showChatDialog" class="chat-dialog" style="position: absolute;"
                :style="{ 'left': dialogLeft, 'top': dialogTop, bottom: dialogBottom }">
                <div class="chat-dialog-top">
                    <img class="small-hand" :src="require('@/assets/images/theme1/common/small-hand.png')">
                    <span class="chat-dialog-title"> 
                        <span v-if="roleType === 2"> Hi，我是赢赢，你的AI助手!</span>
                        <span v-if="roleType === 1">  Hi，我是赢赢，你的AI助教~</span>
                    </span>
                    <div class="close-btn" @click.stop="closeDialog()">
                        <img class="close-img" :src="require('@/assets/images/theme1/common/close-small.png')">
                    </div>

                </div>
                <div ref="chatContainer" class="chat-dialog-main">
                    <div v-for="(msg, index) in messages" :key="index" class="message"
                        :class="msg.sender === '你' ? 'me-message' : 'ai-message'">
                        <!-- <el-image v-if="msg.image && msg.sender === '你'"
                        style="width: 100px; height: 100px;margin-bottom: 10px;" :src="msg.image" /> -->
                        <span class="message-content" v-if="msg.content" v-html="msg.content"></span>
                    </div>
                    <div v-if="loading" class="chat-loading-container">
                        <div class="chat-loading-bubble"></div>
                        <div class="chat-loading-bubble"></div>
                        <div class="chat-loading-bubble"></div>
                    </div>
                    <div v-if="!loading && messages[messages.length - 1] && messages[messages.length - 1].sender === 'AI'"
                        class="reanswer" @click="anewAnswer"><i class="el-icon-refresh-right"></i>重新回答</div>

                </div>
                <div class="chat-dialog-bottom">
                    <el-input class="question-input" v-model="userMessage" placeholder="可以问我任何问题"
                        @keyup.enter.native="sendMessage"></el-input>
                    <img v-if="!userMessage" class="close-img"
                        :src="require('@/assets/images/theme1/common/send-question-disabled.png')">
                    <img v-else class="close-img" @click="sendMessage"
                        :src="require('@/assets/images/theme1/common/send-question.png')">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import httpCommon from "@/components/tools/request/common.js"
import utils from "@/components/tools/utils.js"
import MarkdownIt from 'markdown-it';
export default {
    data () {
        return {
            roleType: '',
            isDragging: false,
            startX: 0,
            startY: 0,
            left: window.innerWidth - 120, // 初始位置
            top: window.innerHeight - 620,
            headPortraitImage: require('@/assets/images/theme1/common/yy.png'),
            showGreetSb: false,
            showChatDialog: false,
            userMessage: '',
            loading: false,
            messages: [],
            threshold: 5,
            dialogLeft: '-615px',
            dialogTop: 0,
            dialogBottom: 0,
            md: new MarkdownIt(),
            originClientX: '',
            originClientY: '',
            index: 0,
            displayedAnswer: ''
        };
    },
    mounted () {
        let userInfo = localStorage.getItem('user-info-4.2')
        if (userInfo) {
            this.roleType = JSON.parse(userInfo).roleType
        }

    },
    methods: {

        // 重新回答
        anewAnswer () {
            const lastElementWithIdOne = this.messages.reduce((lastMatch, current) => {
                if (current.sender === '你') {
                    return current;
                }
                return lastMatch;
            }, null);
            this.index = 0
            this.displayedAnswer = ''
            if (!lastElementWithIdOne.content) {
                return
            }
            this.loading = true;
            let message = { question: lastElementWithIdOne.content }
            httpCommon.getAIMessage(message).then(res => {
                if (utils.requestSuccess(res)) {
                    let obj = { sender: 'AI', content: '' }
                    this.messages.push(obj);
                    this.typeAnswer(res.data, obj)
                }
                this.loading = false;
            })
        },
        async sendMessage () {
            if (this.userMessage.trim() === '') {
                return;
            }
            this.loading = true;
            // 添加用户发送的消息到消息列表
            this.messages.push({ sender: '你', content: this.userMessage });

            this.$nextTick(() => {
                this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight;
            })
            //
            // // 模拟获取AI回复，实际需替换为真实请求后端获取回复的逻辑
            // this.messages.push({ sender: 'AI', content: 'ai回复' });
            this.index = 0
            this.displayedAnswer = ''
            let message = { question: this.userMessage }
            httpCommon.getAIMessage(message).then(res => {
                if (utils.requestSuccess(res)) {
                    let obj = { sender: 'AI', content: '' }
                    this.messages.push(obj);
                    this.typeAnswer(res.data, obj)

                }
                this.loading = false;
            })
            this.userMessage = '';
        },
        typeAnswer (fullAnswer, obj) {
            if (this.index < fullAnswer.length) {
                this.displayedAnswer += fullAnswer[this.index];
                this.index++;
                setTimeout(() => {
                    this.typeAnswer(fullAnswer, obj);
                    obj.content = this.md.render(this.displayedAnswer)
                    this.$nextTick(() => {
                        this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight;
                    });
                }, 50);
            }
        },
        closeDialog () {
            this.showChatDialog = false
        },
        handleMouseOver () {
            this.showGreetSb = true
        },
        handleMouseOut () {
            this.showGreetSb = false
        },
        handleMouseDown (event) {
            // console.log('鼠标点击');
            this.startX = event.clientX - this.left;
            this.startY = event.clientY - this.top;
            this.originClientX = event.clientX
            this.originClientY = event.clientY
            document.addEventListener('mousemove', this.handleMouseMove);
            document.addEventListener('mouseup', this.handleMouseUp);
        },
        handleMouseMove (event) {
            // console.log('鼠标移动');
            // const distanceX = Math.abs(event.clientX - this.startX);
            // const distanceY = Math.abs(event.clientY - this.startY);

            let newStartX = Math.abs(event.clientX - this.originClientX)
            let newStartY = Math.abs(event.clientY - this.originClientY)
            if (newStartX > this.threshold || newStartY > this.threshold) {
                this.isDragging = true;
                if (this.isDragging) {
                    this.left = event.clientX - this.startX;
                    this.top = event.clientY - this.startY;
                }
            } else {
                this.isDragging = false;
            }

        },
        handleMouseUp () {
            // console.log('鼠标...');

            // this.isDragging = false;
            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseup', this.handleMouseUp);
            if (this.isDragging) {
                // console.log('拖动事件');
                this.adsorb();
            } else {
                // console.log('点击事件');
                this.showChatDialog = true
            }
            this.isDragging = false
        },
        handleTouchStart (event) {
            // console.log('开始移动');
            // this.isDragging = true;
            this.startX = event.touches[0].clientX - this.left;
            this.startY = event.touches[0].clientY - this.top;
            document.addEventListener('touchmove', this.handleTouchMove);
            document.addEventListener('touchend', this.handleTouchEnd);
        },
        handleTouchMove (event) {
            // console.log('移动中');

            if (this.isDragging) {
                this.left = event.touches[0].clientX - this.startX;
                this.top = event.touches[0].clientY - this.startY;
            }


        },
        handleTouchEnd () {
            // console.log('移动结束');
            this.isDragging = false;
            document.removeEventListener('touchmove', this.handleTouchMove);
            document.removeEventListener('touchend', this.handleTouchEnd);
            this.adsorb();
        },
        adsorb () {
            const { innerWidth, innerHeight } = window;
            const ballWidth = 100;
            const ballHeight = 100;

            if (this.left < innerWidth / 2) {
                this.left = 0;
                this.dialogLeft = '105px'
            } else {
                this.left = innerWidth - ballWidth;
                this.dialogLeft = '-615px'
            }

            if (this.top < 0) {
                this.top = 42;
            } else if (this.top > innerHeight - ballHeight) {
                this.top = innerHeight - ballHeight;
            }
            if (this.top < 250) {
                this.dialogTop = 0
                this.dialogBottom = 'auto'
            } else if (this.top > 540) {
                this.dialogBottom = '-100px'
                this.dialogTop = 'auto'
            }
            else {
                this.dialogTop = '-230px'
            }
        }
    },

};
</script>

<style lang="scss" scoped>
.floating-ball-container {
    position: relative;

    .greet-sb-img {
        width: 100px;
        height: 48px;
        position: absolute;
        top: -40px;
        left: 0;
        font-size: 14px;
    }
}

.floating-ball {
    position: fixed;
    z-index: 9999;
    width: 100px;
    height: 100px;
    /* background-color: #007bff;
    border-radius: 50%; */
    background-size: 100% 100%;
    cursor: pointer;


}

.greet-sb-text {}

.chat-dialog {
    border-radius: 10px;
    background: linear-gradient(180deg, #CED0FF 0%, #FDECE4 27.3%, #FFF 100%);
    width: 600px;
    height: 600px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.chat-dialog-top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .small-hand {
        width: 40px;
        height: 40px;
    }

    .chat-dialog-title {
        font-size: 24px;
        font-weight: 700;
        flex: 1;
        color: #4360e7;
    }

    .close-btn {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #9F8AFE;
        border-radius: 50%;

        .close-img {
            width: 18px;
            height: 18px;
        }
    }
}



.close-btn:hover {
    background-color: #4E54E1
}

.chat-dialog-main {
    border-radius: 10px;
    background: #FBFCFF;
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    font-size: 14px;

    .me-message {
        border-radius: 16px 0px 16px 16px;
        background: linear-gradient(90deg, #9F8AFE 0%, #6D7CFB 100%);
        color: #FFF;
        padding: 12px;
        font-size: 14px;
        width: fit-content;
        float: right;
        clear: both;
        margin-bottom: 15px;

        span {
            user-select: text;
            cursor: text;
        }

    }

    .ai-message {
        padding: 0 12px;
        border-radius: 0px 16px 16px 16px;
        background: #F5F6FA;
        color: #303133;
        width: fit-content;
        float: left;
        clear: both;
        margin-bottom: 15px;
        font-size: 14px;

        span {
            user-select: text;
            cursor: text;
        }

    }

    .message-content {
        font-size: 14px;
    }
}

.chat-dialog-bottom {
    border-radius: 30px;
    border: 1px solid #4E54E1;
    background: #FFF;
    padding: 10px 20px;
    display: flex;
    align-items: center;

    .question-input {
        /deep/ .el-input__inner {
            border: none;
            padding: 0 30px 0 0;
            height: 30px;
            line-height: 30px;
        }
    }

    .close-img {
        width: 30px;
        height: 30px;
    }
}

.yy-head-portrait {
    width: 100px;
    height: 100px;
}

.chat-loading-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 50px;
    float: left;
    clear: both;
}

.chat-loading-bubble {
    width: 10px;
    height: 10px;
    background-color: #606266;
    border-radius: 50%;
    margin: 0 3px;
    animation: chatLoading 1s ease-in-out infinite;
}

.chat-loading-bubble:nth-child(2) {
    animation-delay: 0.3s;
}

.chat-loading-bubble:nth-child(3) {
    animation-delay: 0.6s;
}

.reanswer {
    border-radius: 15px;
    border: 1px solid #ECECEC;
    background: #FFF;
    padding: 4px 6px;
    color: #303133;
    font-size: 10px;
    width: fit-content;
    float: left;
    clear: both;

}

.message-box {}

@keyframes chatLoading {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

/* 隐藏默认滚动条 */
::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background-color: rgba(#888, 0.4);
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/aiAssistant.vue